<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editData" ref="editDataRef" label-width="110px">
        <el-form-item label="新闻类型">
          <el-select v-model="editData.newstype" placeholder="请选择" class="select">
            <el-option
              v-for="item in newstypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="新闻标题" class="addAdminForm">
          <el-input v-model="editData.title" placeholder="请输入新闻标题"></el-input>
        </el-form-item>
        <el-form-item label="新闻简介" class="addAdminForm">
          <el-input v-model="editData.info" type="textarea" :rows="5" placeholder="请输入新闻简介"></el-input>
        </el-form-item>
        <el-form-item label="来源图标" class="addAdminForm">
          <el-input v-model="editData.fromlogo" placeholder="请输入来源图标"></el-input>
        </el-form-item>
        <el-form-item label="来源名称" class="addAdminForm">
          <el-input v-model="editData.fromname" placeholder="请输入来源名称"></el-input>
        </el-form-item>
        <el-form-item label="父新闻编号" class="addAdminForm">
          <el-input v-model="editData.parentid" placeholder="请输入父新闻编号"></el-input>
        </el-form-item>
        <el-form-item label="是否热点">
          <el-select v-model="editData.ishot" placeholder="请选择" class="select">
            <el-option
              v-for="item in isList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细内容">
          <VueUeditorWrap v-model="editData.content" :config="myConfig"></VueUeditorWrap>
        </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    VueUeditorWrap
  },
  data () {
    return {
      newstypeList: [],
      isList: [
        { value: '1', label: '是' },
        { value: '0', label: '否' }
      ],
      editData: {
        id: '0',
        newstype: '',
        title: '',
        info: '',
        content: '',
        fromlogo: '',
        fromname: '',
        parentid: '',
        ishot: ''
      },
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 500,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口
        serverUrl: '',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
      }
    }
  },
  mounted () {
    this.newstypeList = Vue.prototype.FunGetNewsType()
  },
  methods: {
    LoadData (row) {
      this.editData.id = row.Id
      this.editData.newstype = row.Newstype.toString()
      this.editData.title = row.Title
      this.editData.info = row.Info
      this.editData.content = row.Content
      this.editData.fromlogo = row.Fromlogo
      this.editData.fromname = row.Fromname
      this.editData.parentid = row.Parentid
      this.editData.ishot = row.Ishot.toString()
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.EditKgjtWebsiteNews()
    },
    EditKgjtWebsiteNews: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editData.id,
        newstype: that.editData.newstype,
        title: that.editData.title,
        info: that.editData.info,
        content: that.editData.content,
        fromlogo: that.editData.fromlogo,
        fromname: that.editData.fromname,
        parentid: that.editData.parentid,
        ishot: that.editData.ishot
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditKgjtWebsiteNews, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
